import makeRequest from "@/api/makeRequest";
import {
  LoginPayload,
  LoginResponse,
  MeResponse,
} from "@/api/rest/auth/AuthTypes";

const AuthApi = {
  login: async (payload: LoginPayload): Promise<LoginResponse> => {
    const { data } = await makeRequest<LoginResponse>({
      url: `/auth/login`,
      method: "post",
      data: payload,
    });
    return data;
  },
  me: async (): Promise<MeResponse> => {
    const { data } = await makeRequest<MeResponse>({
      url: `/auth/me`,
      method: "get",
    });
    return data;
  },
};

export default AuthApi;
